import { createContext, useContext } from "react";

import { SectionScoreTableRow } from "api/api-types-assessment";

export type SectionScoreTableContextValue = {
  rows: SectionScoreTableRow[] | null;
  isLoading: boolean;
  error: Error | null;
};

export const SectionScoreTableContext = createContext<SectionScoreTableContextValue>({
  rows: null,
  isLoading: false,
  error: null,
});

export const useSectionScoreTable = (): SectionScoreTableContextValue =>
  useContext(SectionScoreTableContext);
